import { StatePill } from "@ficatranquilo/contabilidade.com-ui";

/** Status por entidade: [tom, rótulo]. A StatePill não tem ícone: tons iguais com sentidos diferentes se separam pelo texto. */
export const STATUS = {
  contrato: { ativo: ["success", "Ativo"], pausado: ["warning", "Pausado"], encerrado: ["neutral", "Encerrado"], rascunho: ["neutral", "Rascunho"] },
  horas: { aguardando: ["warning", "Aguardando"], aprovado: ["success", "Aprovado"], reprovado: ["danger", "Reprovado"], nota_emitida: ["info", "Nota emitida"] },
  valorVariavel: { pendente: ["warning", "Pendente"], aprovado: ["success", "Aprovado"], reprovado: ["danger", "Reprovado"] },
  notaFiscal: { pendente: ["warning", "Pendente"], aprovada: ["info", "Aprovada"], recusada: ["danger", "Recusada"], paga: ["success", "Paga"] },
  pagamento: { pendente: ["warning", "Pendente"], pago: ["success", "Pago"], atrasado: ["danger", "Atrasado"], cancelado: ["neutral", "Cancelado"] },
  ajustePonto: { pendente: ["warning", "Pendente"], aprovado: ["success", "Aprovado"], reprovado: ["danger", "Reprovado"] },
  prestador: { ativo: ["success", "Ativo"], primeiro_acesso: ["warning", "Aguardando primeiro acesso"], desligada: ["neutral", "Desligada"], administrador: ["info", "Administrador"] },
  importacao: { importado: ["success", "Importado"], vinculado: ["success", "Vinculado"], ignorado: ["warning", "Ignorado"], falhou: ["danger", "Falhou"] },
  questionario: { respondido: ["success", "Respondido"], pendente: ["warning", "Pendente"], ativo: ["success", "Ativo"], inativo: ["neutral", "Inativo"] },
  chaveApi: { ativa: ["success", "Ativa"], expirada: ["warning", "Expirada"], revogada: ["neutral", "Revogada"] },
};

/** Tom do OneWork → variante da StatePill. As cores não mudam com o tema da empresa. */
export const TONE_TO_VARIANT = { success: "green", warning: "orange", danger: "red", info: "blue", neutral: "gray" };

/** Status de uma entidade do OneWork (`domain` + `value`), sempre com o mesmo tom e rótulo. `size` sm → StatePill small, md → default. */
export default function DomainStatus({ domain, value, size = "sm", children }) {
  const def = (STATUS[domain] || {})[value];
  if (!def && !value) return null;
  const [tone, label] = def || ["neutral", String(value)];
  return (
    <span data-status={def ? `${domain}:${value}` : undefined} style={{ display: "inline-flex" }}>
      <StatePill $text={children || label} $variant={TONE_TO_VARIANT[tone]} $size={size === "md" ? "default" : "small"} />
    </span>
  );
}
